<template>
  <AppPageHeader :title="project.name">
    <template #title>
      <slot name="title">
        <div class="flex flex-col gap-2">
          <div class="flex flex-col sm:flex-row sm:items-center gap-2">
            <h2 class="text-xl sm:text-2xl leading-7 sm:truncate sm:tracking-tight">{{ project.name }}</h2>
            <ProjectStatusBadge :status="project.status" class="w-max" />
          </div>
          <ProjectTypeBadge :type="project.type" class="w-max" />
        </div>
      </slot>
    </template>
    <template #actions>
      <slot v-if="!hideActions" name="actions">
        <div class="flex flex-col sm:flex-row gap-2">
          <BaseButton 
            :to="{ name: 'EditProject', params: { customerId: project.customerId, projectId: project.id } }" 
            variant="accent"
            class="w-full sm:w-auto"
          >
            Edit
          </BaseButton>
        </div>
      </slot>
    </template>
  </AppPageHeader>
</template>

<script lang="ts" setup>
import AppPageHeader from '@/components/app/AppPageHeader.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import ProjectStatusBadge from '@/components/project/ProjectStatusBadge.vue'
import ProjectTypeBadge from '@/components/project/ProjectTypeBadge.vue'

defineProps({
  project: {
    type: Object,
    required: true
  },
  hideActions: {
    type: Boolean,
    default: false
  }
})
</script>